import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import StoryIntro from './components/StoryIntro';
import CharacterShowcase from './components/CharacterShowcase';
import GameFeatures from './components/GameFeatures';
import LatestArticles from './components/LatestArticles';
import DownloadCTA from './components/DownloadCTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <StoryIntro />
        <CharacterShowcase />
        <GameFeatures />
        <LatestArticles />
        <DownloadCTA />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '樱境物语',
            url: 'https://6shouyou.cn/',
            description: '樱境物语是一款以樱花为主题的沉浸式叙事体验，带你走进唯美的樱境世界，感受物语之美。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://6shouyou.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '樱境物语官方网站 | 沉浸式樱花叙事体验',
            description: '樱境物语是一款以樱花为主题的沉浸式叙事体验，带你走进唯美的樱境世界，感受物语之美。',
            url: 'https://6shouyou.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '樱境物语',
            },
          }),
        }}
      />
    </>
  );
}